import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('liquidacao', 'pagamento/contrato/cadastro');

const pagamentoActions = {
  atualizarStatusPagamento: { method: 'PUT', url: `${basePath}/atualizar` },
};

export default (resource) => resource(`${basePath}`, {}, pagamentoActions);
